<div class="container">

  <h4 class="form-page-name">
      FEMA Training
  </h4>

  <div *ngIf="isContractor() else showHomeownerTraining" class="retrofit-form-text">
    <div class="retrofit-form-text">
      <div [innerHTML]="textFemaTrainingContractor"></div>
    </div>
    <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
      <div fxFlex='25%'>
        <!-- <a mat-stroked-button color="primary"
          href="{{ebbTrainingUrl}}" target="_blank">
          GO TO BRACE BOLT COURSE
        </a> -->
        <a mat-stroked-button color="primary"
        (click)="redirectToEBBTraining()">
        GO TO BRACE BOLT COURSE
      </a>
        <div class="retrofit-form-inline-icon-with-label-container" style="margin-top: 12px;">
          <div *ngIf="currentContact?.femaTrained else showIncompleteTraining">
            <mat-icon class="retrofit-form-inline-icon-with-label" color="accent">assignment_turned_in</mat-icon>
            <span class="retrofit-form-inline-icon-with-label-text">Course Completed</span>
          </div>
          <ng-template #showIncompleteTraining>
            <mat-icon class="retrofit-form-inline-icon-with-label" color="warn">assignment_late</mat-icon>
            <span class="retrofit-form-inline-icon-with-label-text">Course Incomplete</span>
          </ng-template>
        </div>
      </div>
      <div fxFlex='25%' class="ess-content">
        <!-- <a mat-stroked-button color="primary"
          href="{{essTrainingUrl}}" target="_blank">
          GO TO SOFT STORY COURSE
        </a> -->
        <a mat-stroked-button color="primary"
        (click)="redirectToESSTraining()">
        GO TO SOFT STORY COURSE
      </a>

        <div class="retrofit-form-inline-icon-with-label-container" style="margin-top: 12px;">
          <div *ngIf="currentContact?.essFemaTrained else showIncompleteTraining">
            <mat-icon class="retrofit-form-inline-icon-with-label" color="accent">assignment_turned_in</mat-icon>
            <span class="retrofit-form-inline-icon-with-label-text">Course Completed</span>
          </div>
          <ng-template #showIncompleteTraining>
            <mat-icon class="retrofit-form-inline-icon-with-label" color="warn">assignment_late</mat-icon>
            <span class="retrofit-form-inline-icon-with-label-text">Course Incomplete</span>
          </ng-template>
        </div>
      </div>
      <div fxFlex='25%' class="emr-content">
      
        <a mat-stroked-button color="primary"
        (click)="redirectToEMRTraining()">
        GO TO MULTI-UNIT COURSE
      </a>
  
        <div class="retrofit-form-inline-icon-with-label-container" style="margin-top: 12px;">
          <div *ngIf="currentContact?.emrFemaTrained else showIncompleteTraining">
            <mat-icon class="retrofit-form-inline-icon-with-label" color="accent">assignment_turned_in</mat-icon>
            <span class="retrofit-form-inline-icon-with-label-text">Course Completed</span>
          </div>
          <ng-template #showIncompleteTraining>
            <mat-icon class="retrofit-form-inline-icon-with-label" color="warn">assignment_late</mat-icon>
            <span class="retrofit-form-inline-icon-with-label-text">Course Incomplete</span>
          </ng-template>
        </div>
      </div>
    
    </div>

  </div>
  <ng-template #showHomeownerTraining>
    <h6 style="margin-top: 12px;">Do It Yourself Training</h6>
    <mat-divider style="margin-bottom: 9px;"></mat-divider>
    <div class="retrofit-form-text">
      <div [innerHTML]="textFemaTrainingHomeowner"></div>

     
      
    </div>
    <div >

    <a  mat-stroked-button color="primary"
    (click)="redirectToEBBTraining()">
    LEARN HOW TO DO IT YOURSELF
    </a>
  </div>
  
  </ng-template>

  <div style="min-height: 50px;"></div>

</div>
